import { Button } from '@sunstone/ui';
import type { BlockRendererProps } from '../registry';

export function ApprovalBlockRenderer({ block }: BlockRendererProps) {
  return (
    <div className="my-2 rounded-md border border-border p-3">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-1">
        Approval Required
      </div>
      <div className="text-sm mb-2">{block.content}</div>
      <div className="flex gap-2">
        <Button size="sm" disabled>
          Approve
        </Button>
        <Button variant="outline" size="sm" disabled>
          Reject
        </Button>
      </div>
    </div>
  );
}
